import { IReward } from './IReward';
import { Reward } from './Reward';
import PosTransactionTypes from './PosTransactionTypes';

export class CashBackReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.CashBackReward';

	public static readonly NAME: string = 'Cash Back';

	transactionType: string = PosTransactionTypes.ALL.value;

	cashBackRate: number = 0;

	purchaseLimit: number = 0;

	constructor(reward?: IReward) {
	  super(CashBackReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.cashBackRate = (reward as any).cashBackRate;
	    this.purchaseLimit = (reward as any).purchaseLimit;
	    this.transactionType = (reward as any).transactionType;
	  }
	}

	getDescription(): string {
	  return `${this.cashBackRate}% cash back on up to $${
	    this.purchaseLimit} in purchases`;
	}

	clone(): IReward {
	  const clone = new CashBackReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default CashBackReward;
